var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","label":"","outlined":"","color":_vm.statusColor(_vm.status)}},[_vm._v(" "+_vm._s(_vm.statusLabel(_vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }